import React from 'react';
import { Icon } from '@workboard/action-item';
import { getAiTypeAttributes, getStateComponentIcon } from '../../board/utils';
import TitleOfAi from './titleOfAi';
import {
  WbEventHandlerMixins, 
} from '../../utils/common';
import TopicAttachment from './topicAttachment';
import CommonTags from './commonTags';
import ImgIconComp from "../imgcomp";

import { WoboFileUploadService } from '../../../src/services/fileupload.service'

// List Topic content
class ActionItemDetailsDiv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'topic',
      tag: 0,
      act: 'edit',
    };
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.goalDetailPage = this.goalDetailPage.bind(this);
  }

  handleFileDownload(e, item) {
    e.preventDefault();
    const { isNoAttachmentDownload } = this.props;
    if (!isNoAttachmentDownload) return;
    if (item.fusType == 1 && item.fusStatus == 1) {
      const link = document.createElement('a');
      const url = `${wbConfig.baseUrl}`+ '/vnext/fus/api/v1/download/' + item.fileSignature
      WoboFileUploadService.download(url).then(async (res)=>{
          const blob = await res.blob();
          const blobUrl = URL.createObjectURL(new Blob([blob]));
          link.href = blobUrl;
          link.target = "_blank";
          link.setAttribute(
              "download",
              item.file_name
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
    } else if(item.fusType != 1) {
     return window.open(item.path, '_blank');
   }
  }

  goalDetailPage(goalId, metricId, viewAccess = 'true') {
    if (viewAccess == 'false') {
      return;
    }
    const params = {};
    if (typeof goalId !== 'undefined' && goalId != '') {
      params.id = goalId;
    }
    if (typeof metricId !== 'undefined' && metricId != '') {
      params.id = goalId;
      params.metricId = metricId;
    }
    return viewGoalDetailsPage(undefined, params);
  }

  renderRecurringIcon (item) {
    const { recurringTopic } = item;

    if (recurringTopic === 1){
      return (
          <div style={{position: 'relative', bottom:'30px', left:'3px'}} >
            <ImgIconComp
                id="recurringTemp"
                class="recuuringPic dispIB "
                width="20"
                height="20"
            />
          </div>
      );
    }

    return null;
  }

  render() {
    const { meeting } = this.props;
    const topic = this.props.topics;
    const ai_id = (topic.ai_id) ? topic.ai_id : '';
    const woboTypeTopic = !!((topic.wobo_type === 'topic' && topic.tag != 1));
    let stateCompName = '';
    if (topic.wobo_type === 'ai') {
      const { type, state } = topic.wobo_data || {};
      const { attributes } = getAiTypeAttributes(type || 0);
      stateCompName = getStateComponentIcon(
        attributes?.state?.values ?? [],
        state
      );
    }

    return (
      <div className="wb-table-row WbActRow wb-item-selector cursorDefault" activity-id={ai_id} data-id={ai_id} data-type="">
        <div className="wb-table tabLayFix  ">
          <div className="wb-table-row " style={{ cursor: 'default' }} data-type="topic">
            <div className="wb-table-col wb-table-col-tag tagForAi" style={(woboTypeTopic) ? {position: 'absolute', width: 'min-content'}:{}}>
              {
              (woboTypeTopic)
                ? <CommonTags ai_id={topic.ai_id} key={`topic_${topic.id}`} meeting={meeting} owner={topic.added_by} currentUser={this.props.currentUser} tag={topic.tag} topicId={topic.id} type={this.state.type} act={this.state.act} meetingId={meeting.id} id={topic.id} saveTags={this.props.saveTags} userPermission={this.props.userPermission} />
                : (
                  <div className="meeting-tag-wrapper" style={{ paddingTop: '3px' }}>
                    { topic.wobo_type === 'objective'
                      && <div className="meeting-tag-options meetingCursorPointer" data-view-acces={topic.wobo_data.view_access} data-tag={topic.wobo_type_id} data-type={topic.wobo_type} onClick={() => this.goalDetailPage(topic.wobo_data.id, undefined, topic.wobo_data.view_access)} />
                    }
                    { topic.wobo_type === 'ai' && topic.wobo_data != ''
                      && (
                      <div className="wb-table-col-edit-title-desc wrap meetingCursorPointer  iconArea " data-view-acces={topic.wobo_data.view_access} onClick={() => WbEventHandlerMixins.aiDetailPage(topic.wobo_data.id, this, topic.wobo_data.view_access)}>
                        <div className="meeting-tag-options ai-tag-options" data-type={topic.wobo_type}>
                          <Icon name={stateCompName} width="15" height="15" />
                        </div>
                      </div>
                      )
                      }
                    { topic.wobo_type === 'workstream' && topic.wobo_data.view_access == 'true' && (
                    <a className="ai-v1-popup  ws-text-class wb-table-col-edit-title-desc wrap" href={`/wb/activity/workstreams?id=${topic.wobo_data.id}`} target="_blank" style={{ paddingRight: '10px' }}>
                      <div className="meeting-tag-options meeting-workstream-image" data-tag={topic.wobo_type_id} data-type={topic.wobo_type} />
                    </a>
                    )}
                    { topic.wobo_type === 'workstream' && topic.wobo_data.view_access == 'false' && (
                    <div className="ai-v1-popup  ws-text-class wb-table-col-edit-title-desc wrap">
                      <div className="meeting-tag-options meeting-workstream-image meetingCursorPointer" data-view-acces={topic.wobo_data.view_access} data-tag={topic.wobo_type_id} data-type={topic.wobo_type} />
                    </div>
                    )}
                    { topic.wobo_type === 'attachment'
                      && <div className="meeting-tag-options" data-tag={topic.wobo_type_id} data-type={topic.wobo_type} onClick={e => this.handleFileDownload(e, topic.wobo_data)} />
                    }
                    { topic.wobo_type === 'key_result'
                      && <div className="meeting-tag-options meetingCursorPointer" data-view-acces={topic.wobo_data.view_access} data-tag={topic.wobo_type_id} data-type={topic.wobo_type} onClick={() => this.goalDetailPage(topic.wobo_data.goal_id, topic.wobo_data.metric_id, topic.wobo_data.view_access)} />
                    }
                    { topic.wobo_type === 'attachment_link'
                      && <div className="meeting-tag-options meetingCursorPointer" data-view-acces={topic.wobo_data.view_access} data-tag={topic.wobo_type_id} data-type={topic.wobo_type} onClick={() => this.goalDetailPage(topic.wobo_data.goal_id, topic.wobo_data.metric_id, topic.wobo_data.view_access)} />
                    }
                    { topic.wobo_type === 'topic' && topic.tag == 1
                      && (
                      <div className="wb-table-col-edit-title-desc wrap meetingCursorPointer  topicTagArea " data-view-acces="true" onClick={() => WbEventHandlerMixins.aiDetailPage(topic.wobo_data.id, this, true)}>
                        <div className="meeting-tag-options" data-tag="1" data-type={topic.wobo_type} />
                      </div>
                      )
                    }
                  </div>
                )
              }
            </div>
            <TitleOfAi
              meeting={meeting}
              topicMiddle={topic}
              refreshLegacyData ={this.props.refreshLegacyData}
              editTopicArea={this.props.editTopicArea}
              deleteTopicTakeNonTake={this.props.deleteTopicTakeNonTake}
              updateTopicTake={this.props.updateTopicTake}
              currentUser={this.props.currentUser}
              shareMeetingTopic={this.props.shareMeetingTopic}
              saveTags={this.props.saveTags}
              userPermission={this.props.userPermission}
              addTopicAttach={this.props.addTopicAttach}
              mtS3Data={this.props.mtS3Data}
              actions={this.props.actions}
              disableHoverStick={this.props.disableHoverStick}
              editTopicDescEdit={this.props.editTopicDescEdit}
              isNoAttachmentDownload={this.props.isNoAttachmentDownload}
              showKebabMenu={this.showKebabMenu}
              displayKrConfidence={this.props.displayKrConfidence}
              accessToken={this.props.accessToken}
              appInID={this.props.appInID}
              isFUSEnabled={this.props.isFUSEnabled}
              updateTopicAttach={this.props.updateTopicAttach}
              deleteTopicAttach={this.props.deleteTopicAttach}
            />

          </div>
          {this.renderRecurringIcon(topic)}
        </div>
        {
        (typeof topic.files !== 'undefined' && (topic.files).length > 0)
        && <TopicAttachment meeting={meeting} topicMiddle={topic} topicFile={topic.files} currentUser={this.props.currentUser} userPermission={this.props.userPermission} deleteTopicAttach={this.props.deleteTopicAttach} isNoAttachmentDownload={this.props.isNoAttachmentDownload} isFUSEnabled={this.props.isFUSEnabled} />
        }
        <div className="clear" />
      </div>
    );
  }
}
export default ActionItemDetailsDiv;
